var PsrProfileSelectorForm = (function() {
    var cachedDOM = {};

    return {
        init: function() {
            cachedDOM.$form = $(".form-profile");
            cachedDOM.$formSelectProfile = $(
                "[data-action-type='select-profile']"
            );
            cachedDOM.$formSaveProfile = $("[data-action-type='save-profile']");
            cachedDOM.$formSolarRevolution = $(
                "[data-action-type='confirm-solar-revolution']"
            );
            cachedDOM.$userCode = $("[name='userCode']");
            cachedDOM.$productStudy = $("[name='productStudy']");
            cachedDOM.$summertimeOption = $("[name='summertimeOption']");
            cachedDOM.$dontKnowBirthTime = $("#form-dontKnowBirthTime");
            cachedDOM.$minute = $("[name='minute']");
            cachedDOM.$hour = $("[name='hour']");
            cachedDOM.$numerologyProfileId = $("[name='numerologyProfileId']");
            cachedDOM.$numerologyProfileGender = $(
                "[name='numerologyProfileGender']"
            );
            cachedDOM.$numerologyProfileBirthDate = $(
                "[name='numerologyProfileBirthDate']"
            );
            cachedDOM.$userProfileName = $("#userProfileName");
            cachedDOM.$solarRevolutionProfileId = $(
                "[name='solarRevolutionProfileId']"
            );
            cachedDOM.$solarRevolutionProfileBirthdate = $(
                "[name='solarRevolutionProfileBirthdate']"
            );
            cachedDOM.$solarRevolutionUserProfileName = $(
                "#solarRevolutionUserProfileName"
            );
            cachedDOM.$profileFeedback = $(".form-profile-feedback");
            cachedDOM.$formSaveProfileFields = cachedDOM.$formSaveProfile.find(
                "input, select, checkbox"
            );

            cachedDOM.$numerologyForecastProfileId = $("[name='numerologyForecastProfileId']");
            cachedDOM.$numerologyForecastProfileGender = $("[name='numerologyForecastProfileGender']");
            cachedDOM.$numerologyForecastProfileBirthDate = $("[name='numerologyForecastProfileBirthDate']");
            cachedDOM.$numerologyForecastUserProfileName = $("[name='numerologyForecastUserProfileName']");
            cachedDOM.$numerologyForecastUserProfileNameText = $('#numerologyForecastUserProfileNameText');

            this.events();
        },

        defaultError: function(actionName) {
            alert(
                "Ops... Ocorreu um problema na " + actionName + " do perfil."
            );
            PsrProfileSelectorModal.closeAll();
        },

        events: function() {
            cachedDOM.$form.on(
                "submit",
                PsrProfileSelectorForm.handleFormSubmit
            );
            cachedDOM.$dontKnowBirthTime.on(
                "change",
                PsrProfileSelectorForm.handleChangeDontKnowBirthTime
            );
        },

        handleChangeDontKnowBirthTime: function(event) {
            if (event.target.checked) {
                PsrProfileSelectorForm.disableBirthTimeFields();
                return;
            }

            PsrProfileSelectorForm.activeBirthTimeFields();
        },

        activeBirthTimeFields: function() {
            cachedDOM.$minute
                .removeClass("is-disabled")
                .attr("disabled", false);
            cachedDOM.$hour.removeClass("is-disabled").attr("disabled", false);
        },

        disableBirthTimeFields: function() {
            cachedDOM.$minute
                .addClass("is-disabled")
                .attr("disabled", true)
                .val("");
            cachedDOM.$hour
                .addClass("is-disabled")
                .attr("disabled", true)
                .val("");
        },

        errorEmptyFields: function(fields) {
            var msg = "";
            msg += "Por favor, preencha corretamente os campos abaixo: \n";

            fields.forEach(function(field) {
                if (FIELD_NAME_MAP[field]) {
                    msg += "\n - " + FIELD_NAME_MAP[field];
                }
            });

            alert(msg);
        },

        validateForm: function(values) {
            var emptyFields = [];

            $.each(values, function(name, value) {
                if (name === "selectedProfileId" || name === "nickname") {
                    return;
                }

                if (!value) {
                    emptyFields.push(name);
                }
            });

            if (values.dontKnowBirthTime) {
                emptyFields = emptyFields.filter(function(item) {
                    return item !== "hour" && item !== "minute";
                });
            }

            if (emptyFields.length > 0) {
                this.errorEmptyFields(emptyFields);
                return false;
            }

            return true;
        },

        selectProfileAction: function() {
            PsrProfileSelectorModal.next();
        },

        saveProfileAction: function() {
            var values = this.serializeForm(cachedDOM.$formSaveProfile);

            if (!this.validateForm(values)) {
                return PsrLoader.stop();
            }

            if (values.dontKnowBirthTime) {
                return this.saveProfile();
            }

            this.checkSummertime();
        },

        confirmSolarRevolutionAction: function() {
            var values = this.serializeForm(cachedDOM.$formSolarRevolution);

            if (!this.validateForm(values)) {
                return PsrLoader.stop();
            }

            return GenericProductHandler.generate();
        },

        handleFormSubmit: function(event) {
            event.preventDefault();

            var actionType = event.target.dataset.actionType;

            PsrLoader.start();

            if (actionType === "select-profile") {
                return PsrProfileSelectorForm.selectProfileAction();
            }

            if (actionType === "save-profile") {
                return PsrProfileSelectorForm.saveProfileAction();
            }

            if (actionType === "confirm-summertime") {
                return PsrProfileSelectorForm.saveProfile(
                    $("[name='summertimeOption']:checked").val()
                );
            }

            if (actionType === "confirm-numerology") {
                return GenericProductHandler.generate();
            }

            if (actionType === 'confirm-numerology-forecast') {
                return GenericProductHandler.generate();
            }

            if (actionType === "confirm-solar-revolution") {
                return PsrProfileSelectorForm.confirmSolarRevolutionAction();
            }
        },

        generateEditFormMap: function(values) {
            var resolvedDate = PsrHelpers.yyyymmddToDate(
                values.BirthDate,
                values.BirthTime
            );
            var month = resolvedDate.getMonth() + 1;
            var day = resolvedDate.getDate();
            var hour = resolvedDate.getHours();
            var minute = resolvedDate.getMinutes();
            var keyValueMap = {
                selectedProfileId: values.selectedProfileId,
                name: values.ProfileName,
                nickname: values.NickName,
                psrOndeNasceu: values.CityName,
                gender: values.Gender,
                city: values.CityID,
                country: values.CountryID,
                state: values.EstateID,
                year: resolvedDate.getFullYear(),
                month: month < 9 ? "0" + month : month,
                day: day < 9 ? "0" + day : day,
                hour: hour < 9 ? "0" + hour : hour,
                minute: minute < 9 ? "0" + minute : minute,
                dontKnowBirthTime: false
            };

            if (values.BirthTime === "X") {
                keyValueMap.hour = "";
                keyValueMap.minute = "";
                keyValueMap.dontKnowBirthTime = true;
            }

            return keyValueMap;
        },

        cleanFields: function($fields) {
            $fields.each(function() {
                if (this.type == "checkbox") {
                    return (this.checked = false);
                }

                this.value = "";
            });
        },

        fillFields: function($fields, keyValueMap) {
            $fields.each(function() {
                var value = keyValueMap[this.getAttribute("name")];

                if (!value) {
                    return;
                }

                if (this.type == "checkbox") {
                    return (this.checked = value);
                }

                this.value = value;
            });
        },

        fillEditFormFields: function(data) {
            var keyValueMap = PsrProfileSelectorForm.generateEditFormMap(data);
            var $fields = cachedDOM.$formSaveProfileFields;

            PsrProfileSelectorForm.cleanFields($fields);
            PsrProfileSelectorForm.fillFields($fields, keyValueMap);
        },

        cleanForm: function() {
            var $fields = cachedDOM.$formSaveProfileFields;

            PsrProfileSelectorForm.cleanFields($fields);
        },

        fillSolarRevolutionFormFields: function(profile) {
            cachedDOM.$solarRevolutionProfileId.val(profile.ProfileID);
            cachedDOM.$solarRevolutionProfileBirthdate.val(profile.BirthDate);

            cachedDOM.$solarRevolutionUserProfileName.text(profile.ProfileName);

            PsrCityAutocomplete.setInputTarget({
                elementId: "solar-revolution-psr-autocomplete"
            });

            PsrCityAutocomplete.emptyFields();
            PsrProfilePeriodSelect.populateSelect(profile);
        },

        fillNumerologyFormFields: function(profile) {
            cachedDOM.$numerologyProfileId.val(profile.ProfileID);
            cachedDOM.$numerologyProfileGender.val(profile.Gender);
            cachedDOM.$numerologyProfileBirthDate.val(profile.BirthDate);

            cachedDOM.$userProfileName.text(profile.ProfileName);
        },

        fillNumerologyForecastFormFields: function (profile) {
            cachedDOM.$numerologyForecastProfileId.val(profile.ProfileID);
            cachedDOM.$numerologyForecastProfileGender.val(profile.Gender);
            cachedDOM.$numerologyForecastProfileBirthDate.val(profile.BirthDate);
            cachedDOM.$numerologyForecastUserProfileName.val(profile.ProfileName);
            cachedDOM.$numerologyForecastUserProfileNameText.text(profile.ProfileName);
        },

        saveProfile: function(summertimeOption) {
            var values = this.serializeForm(cachedDOM.$formSaveProfile);
            var birthDate = values.year + values.month + values.day;
            var birthTime = values.dontKnowBirthTime
                ? "X"
                : values.hour + values.minute;
            var resolvedDate = PsrHelpers.summertimeDateResolver(
                birthDate,
                birthTime
            );
            var summertimeBirthDate = PsrHelpers.yyyymmddDateFormat(
                resolvedDate.summertime
            );
            var summertimeBirthTime = PsrHelpers.hhmmTimeFormat(
                resolvedDate.summertime
            );
            var data = {
                ProfileID: values.selectedProfileId,
                userCode: cachedDOM.$userCode.val(),
                hdName: values.name,
                hdNickName: values.nickname,
                hdBirthDate: birthDate,
                hdBirthTime: birthTime,
                hdSummerBirthDate: summertimeBirthDate,
                hdSummerBirthTime: summertimeBirthTime,
                hdGender: values.gender,
                hdCityID: values.city,
                hdCityName: values.psrOndeNasceu,
                ddCountry: values.country,
                rbSummerTimeOption: summertimeOption || 0
            };

            if (values.dontKnowBirthTime) {
                data.hdDontKnowBirthTime = true;
            }

            $.ajax({
                type: "POST",
                url: "/apiV1/users/profile/create",
                data: data,
                dataType: "json"
            }).done(function(data) {
                var saveActionType =
                    values.saveActionType === "edit" ? "edição" : "adição";

                if (data.profileId < 0) {
                    PsrProfileSelectorForm.defaultError(saveActionType);
                } else {
                    PsrProfileSelectorModal.openAction("feedbackSuccess");
                }

                setTimeout(function() {
                    PsrProfileSelectorModal.openAction("profile-select", {
                        selectedProfile: data.profileId
                    });
                }, 1500);
            });
        },

        serializeForm: function(form) {
            var values = {};

            $.each($(form).serializeArray(), function(index, field) {
                values[field.name] = field.value;
            });

            return values;
        },

        checkSummertime: function() {
            var values = this.serializeForm(cachedDOM.$formSaveProfile);
            var birthDate = values.year + values.month + values.day;
            var birthTime = values.hour + values.minute;

            $.ajax({
                type: "GET",
                url: "/apiV1/users/profile/checkSummerTime",
                data: {
                    BirthDate: birthDate,
                    BirthTime: birthTime,
                    CityID: values.city
                },
                dataType: "json"
            }).done(function(data) {
                if (data.isSummerTime) {
                    return PsrProfileSelectorModal.openAction("summertime", {
                        birthTime: birthTime,
                        birthDate: birthDate
                    });
                }

                PsrProfileSelectorForm.saveProfile();
            });
        }
    };
})();
